import React, {useState, useRef, useEffect} from 'react';
import './_multiSelect.scss';

function MultiSelect({options, value, onChange, placeholder = 'Select...', disabled = false}) {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState('');
  const containerRef = useRef(null);

  // Filter options based on search
  const filteredOptions = options.filter(option =>
    option.label.toLowerCase().includes(search.toLowerCase())
  );

  // Close dropdown on outside click
  useEffect(() => {
    function handleClickOutside(event) {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (option) => {
    if (value.some(v => v.value === option.value)) {
      // Remove
      onChange(value.filter(v => v.value !== option.value));
    } else {
      // Add
      onChange([...value, option]);
    }
  };

  const handleRemoveTag = (option) => {
    onChange(value.filter(v => v.value !== option.value));
  };

  return (
    <div className={`multi-select-container${disabled ? ' disabled' : ''}`} ref={containerRef}>
      <div
        className={`multi-select-control${isOpen ? ' open' : ''}`}
        onClick={() => !disabled && setIsOpen(!isOpen)}
        tabIndex={0}
      >
        <div className="multi-select-tags">
          {value.length === 0 && <span className="multi-select-placeholder">{placeholder}</span>}
          {value.map(option => (
            <span className="multi-select-tag" key={option.value}>
                  {/*{`${option.value} - ${option.label}`}*/}
              {option.label}
              <button
                type="button"
                className="multi-select-remove"
                onClick={e => {
                  e.stopPropagation();
                  handleRemoveTag(option);
                }}
                aria-label={`Remove ${option.label}`}
              >
                ×
              </button>
            </span>
          ))}
        </div>
        <span className="multi-select-arrow">▼</span>
      </div>
      {isOpen && !disabled && (
        <div className="multi-select-dropdown">
          <input
            className="multi-select-search"
            type="text"
            value={search}
            onChange={e => setSearch(e.target.value)}
            placeholder="Search..."
            autoFocus
          />
          <div className="multi-select-options">
            {filteredOptions.length === 0 ? (
              <div className="multi-select-no-options">No options</div>
            ) : (
              filteredOptions.map(option => (
                <div
                  key={option.value}
                  className={`multi-select-option${value.some(v => v.value === option.value) ? ' selected' : ''}`}
                  onClick={() => handleSelect(option)}
                >
                  {/*{`${option.value} - ${option.label}`}*/}
                  {option.label}
                  {value.some(v => v.value === option.value) && <span className="multi-select-check">✔</span>}
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default MultiSelect;